export enum EmbedEventName {
  USER_JOINED_CALL = 'user_joined_call',
  USER_LEFT_CALL = 'user_left_call',
  CAMERA_TOGGLE = 'camera_toggle',
  MICROPHONE_TOGGLE = 'microphone_toggle',
  HAND_RAISED = 'hand_raised',
  PAGE_VISIBILITY_CHANGE = 'page_visibility_change',
  READY = 'ready',
  CHAT_TOGGLE = 'chat_toggle',
  PIP_TOGGLE = 'pip_toggle',
  SCREENSHARE_TOGGLE = 'screenshare_toggle',
  RECORDING_STATUS_CHANGE = 'recording_status_change',
  CONNECTION_STATUS_CHANGE = 'connection_status_change',
  DEVICE_PERFORMANCE_STATUS_CHANGE = 'device_performance_status_change',
  USER_ENDED_CALL_FOR_EVERYONE = 'user_ended_call_for_everyone',
  PARTICIPANT_UPDATE = 'participantupdate',
  PARTICIPANT_JOIN = 'participant_join',
  PARTICIPANT_LEAVE = 'participant_leave',
  DEVICE_STATUS_CHANGE = 'device_status_change',
}

export interface EmbedEventMessage {
  type: EmbedEventName;
  detail: any | null;
}
